import { Copy } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

const NAME_FIELD = "Chiara | Coach fitness donne";

const BIOS = [
  ["Versione A — risultato", "Ricomposizione corporea per donne 🌿\nTonica e forte, senza diete estreme\nCoaching 1:1 online\n⬇️ Guida gratis: 7 giorni per iniziare"],
  ["Versione B — anti-dieta", "Aiuto le donne a ricomporsi\nsenza 1200 kcal né allenamenti punitivi\n📍Coaching online · check-in settimanali\n⬇️ Scarica la guida gratuita"],
  ["Versione C — personale", "Fitness coach per donne 25-45\nMeno grasso, più tono, zero sensi di colpa\n💬 Scrivi «GUIDA» in DM\n⬇️ o scaricala qui"],
];

const HIGHLIGHTS = [
  ["Inizia qui", "Chi sei, per chi lavori, cosa offri. 3-4 storie."],
  ["Risultati", "Trasformazioni e messaggi delle clienti (con consenso)."],
  ["Metodo", "Come funziona il coaching: piano, check-in, supporto."],
  ["Miti", "Mito vs realtà: 1200 kcal, cardio, bilancia."],
  ["Ricette", "Pasti proteici veloci."],
  ["FAQ", "Prezzo, durata, a distanza, per chi non è."],
];

const copy = (t) => navigator.clipboard.writeText(t).then(() => toast.success("Copiato"));

export default function BioPanel() {
  const link = `${window.location.origin}/links`;
  return (
    <div className="space-y-4" data-testid="bio-panel">
      <div className="bg-white border border-[#E5E1D8] rounded-2xl p-5 grid sm:grid-cols-2 gap-4">
        <div>
          <p className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#748E63]">Campo «Nome» (si cerca su IG)</p>
          <div className="flex items-center gap-2 mt-2">
            <p className="font-semibold" data-testid="bio-name-field">{NAME_FIELD}</p>
            <Button size="icon" variant="ghost" aria-label="Copia nome" data-testid="bio-copy-name" onClick={() => copy(NAME_FIELD)}><Copy className="w-4 h-4" /></Button>
          </div>
        </div>
        <div>
          <p className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#748E63]">Link da mettere in bio</p>
          <div className="flex items-center gap-2 mt-2">
            <p className="font-semibold break-all text-sm" data-testid="bio-link">{link}</p>
            <Button size="icon" variant="ghost" aria-label="Copia link" data-testid="bio-copy-link" onClick={() => copy(link)}><Copy className="w-4 h-4" /></Button>
          </div>
        </div>
      </div>
      <div className="grid lg:grid-cols-3 gap-3">
        {BIOS.map(([title, text], i) => (
          <div key={title} className="bg-white border border-[#E5E1D8] rounded-2xl p-5 flex flex-col" data-testid={`bio-version-${i}`}>
            <p className="text-sm font-semibold">{title}</p>
            <pre className="whitespace-pre-wrap font-sans text-[15px] leading-relaxed mt-3 flex-1">{text}</pre>
            <div className="flex items-center justify-between mt-4">
              <span className="text-xs text-[#5A625C]">{[...text].length}/150 caratteri</span>
              <Button size="sm" variant="outline" data-testid={`bio-copy-${i}`} onClick={() => copy(text)}><Copy className="w-4 h-4 mr-1" /> Copia</Button>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-white border border-[#E5E1D8] rounded-2xl p-5">
        <p className="font-semibold">Storie in evidenza (in quest'ordine)</p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-3">
          {HIGHLIGHTS.map(([t, d]) => (
            <div key={t} className="border border-[#E5E1D8] rounded-xl p-3">
              <p className="font-display text-xl">{t}</p>
              <p className="text-xs text-[#5A625C] mt-1">{d}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
